import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IconModule } from '../../components/icon/icon.module';
import { UniqueSellingPointComponent } from './unique-selling-point.component';

@NgModule({
  declarations: [UniqueSellingPointComponent],
  imports: [CommonModule, IconModule, TranslateModule],
  exports: [UniqueSellingPointComponent],
})
export class UniqueSellingPointModule {}
